import { Builder, withChildren } from '@builder.io/react';
import ScrollableColumns from './scrollableColumns';
import theme from '../../gatsby-plugin-theme-ui';

Builder.registerComponent(withChildren(ScrollableColumns), {
  name: 'Scrollable Columns',
  inputs: [
    {
      name: 'gap',
      type: 'string',
      enum: [...Object.keys(theme.space).filter((key) => key !== 'mega')],
      defaultValue: 'medium',
      required: false,
    },
    {
      name: 'columnMinWidth',
      type: 'string',
      helperText: 'Minimum width for each column (e.g., "300px", "20rem"). Leave empty for auto-sizing on desktop.',
      required: false,
    },
    {
      name: 'padding',
      type: 'string',
      enum: [...Object.keys(theme.space).filter((key) => key !== 'mega')],
      defaultValue: 'none',
      required: false,
    },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: Object.keys(theme.backgroundColors),
      defaultValue: 'transparent',
    },
    {
      name: 'backgroundColorOverride',
      type: 'color',
      advanced: true,
      required: false,
    },
  ],
});

